module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "ack-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#ack1"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v(" huge thank you to editor Perrin Davis and editorial assistants Caroline Olson and Caitlin Garibaldi for their amazing editing, computer, and indexing skills and dedication in producing this book. Another thank you to Linda Yoakam, R.D., M.S. for the nutritional calculations, which are so helpful. Joan Sommers’ art direction and new cover design are to be applauded. Doug Seibold, your support in producing this book is greatly appreciated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 69
// module chunks = 0